export default __webpack_public_path__ + "static/char-s-58-ja-cc387d8488950a61a1d5d6e29efdca36.png";